import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import RouteNotFound from '../../RouteNotFound';
import SmartBenchmarkPage from './SmartBenchmarkPage';

const SmartBenchmarkHome = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.path} component={SmartBenchmarkPage} />
      <Route path="*">
        <RouteNotFound />
      </Route>
    </Switch>
  );
};

export default SmartBenchmarkHome;
